import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormGroup } from '@angular/forms';

@Component({
  selector: 'description-ras-type-of-report',
  templateUrl: './description-ras-type-of-report.component.html',
  styleUrls: ['./description-ras-type-of-report.component.scss']
})
export class DescriptionRasTypeOfReportComponent implements OnInit {
  @Input() form: FormGroup;
  @Output() formChange = new EventEmitter<FormGroup>();
  constructor() { }

  ngOnInit() {
  }

}
